"use strict";
/**
 * ShortcodeRenderer - 渲染 shortcodes
 * 专注于单个 shortcode 的渲染
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortcodeRenderer = void 0;
const text_template_1 = require("@mdfriday/text-template");
/**
 * ShortcodeRenderer 类
 * 用于注册和渲染单个 shortcode
 */
class ShortcodeRenderer {
    /**
     * 构造函数
     * @param options 渲染选项
     */
    constructor(options) {
        this.shortcodes = new Map();
        this.defaultOptions = {
            preserveUnknownShortcodes: true,
            showWarnings: true
        };
        this.defaultOptions = Object.assign(Object.assign({}, this.defaultOptions), options);
    }
    /**
     * 注册一个函数类型的 shortcode
     * @param name shortcode 名称
     * @param renderFn 渲染函数
     */
    registerShortcode(name, renderFn) {
        this.shortcodes.set(name, {
            name,
            type: 'function',
            render: renderFn
        });
    }
    /**
     * 创建基础数据提供者
     * @param params shortcode 参数
     * @param content shortcode 内容
     * @returns 基础数据提供者对象
     */
    createBaseDataProvider(params, content) {
        return {
            Get: (paramName) => {
                if (typeof paramName === 'number') {
                    return params[paramName];
                }
                // Named parameters in the format name="value"
                const namedParam = params.find(p => p.startsWith(`${paramName}=`));
                if (namedParam) {
                    return namedParam.split('=')[1].replace(/^["']|["']$/g, '');
                }
                return undefined;
            },
            content
        };
    }
    /**
     * 注册一个模板类型的 shortcode
     * @param name shortcode 名称
     * @param config 模板 shortcode 配置
     */
    registerTemplateShortcode(name, config) {
        const tmpl = (0, text_template_1.New)(name);
        if (config.funcMap) {
            tmpl.Funcs(config.funcMap);
        }
        const [parsedTmpl, parseErr] = tmpl.Parse(config.template);
        if (parseErr) {
            throw new Error(`Failed to parse template for shortcode ${name}: ${parseErr}`);
        }
        this.shortcodes.set(name, {
            name,
            type: 'template',
            template: parsedTmpl,
            render: (params, content) => {
                try {
                    // 创建基础数据提供者
                    const baseData = this.createBaseDataProvider(params, content);
                    // 合并用户提供的数据
                    const userData = config.dataProvider ? config.dataProvider(params, content) : {};
                    const data = Object.assign(Object.assign({}, baseData), userData);
                    const [result, execErr] = parsedTmpl.Execute(data);
                    if (execErr) {
                        throw new Error(`Template execution error: ${execErr}`);
                    }
                    return result;
                }
                catch (error) {
                    throw new Error(`Failed to render template shortcode ${name}: ${error instanceof Error ? error.message : String(error)}`);
                }
            }
        });
    }
    /**
     * 批量注册 shortcodes
     * @param shortcodes shortcode 对象
     */
    registerShortcodes(shortcodes) {
        for (const [name, renderFn] of Object.entries(shortcodes)) {
            this.registerShortcode(name, renderFn);
        }
    }
    /**
     * 获取一个 shortcode
     * @param name shortcode 名称
     * @returns shortcode 对象或 undefined
     */
    getShortcode(name) {
        return this.shortcodes.get(name);
    }
    /**
     * 渲染一个 shortcode
     * @param shortcodeItem shortcode 项
     * @param content shortcode 的内容
     * @param options 渲染选项
     * @returns 渲染结果
     */
    renderShortcodeItem(shortcodeItem, content, options) {
        const opts = Object.assign(Object.assign({}, this.defaultOptions), options);
        const shortcode = this.getShortcode(shortcodeItem.name);
        if (!shortcode) {
            if (opts.showWarnings) {
                console.warn(`Unknown shortcode: ${shortcodeItem.name}`);
            }
            if (opts.preserveUnknownShortcodes) {
                // 保留原始标记
                if (shortcodeItem.isClosing) {
                    return shortcodeItem.val;
                }
                if (content) {
                    return shortcodeItem.val + content + `{{< /${shortcodeItem.name} >}}`;
                }
                return shortcodeItem.val;
            }
            return content || '';
        }
        try {
            return shortcode.render(shortcodeItem.params, content);
        }
        catch (error) {
            const errorMessage = error instanceof Error ? error.message : String(error);
            console.error(`Error rendering shortcode ${shortcodeItem.name}:`, errorMessage);
            if (opts.onError) {
                return opts.onError(error instanceof Error ? error : new Error(String(error)), shortcodeItem.name);
            }
            return `Error rendering shortcode ${shortcodeItem.name}: ${errorMessage}`;
        }
    }
}
exports.ShortcodeRenderer = ShortcodeRenderer;
//# sourceMappingURL=shortcodeRenderer.js.map